<div class="button-container">
  <div class="status-container" [ngClass]="{ visible: !hideStatus() }">
    <webchat-status [size]="16"></webchat-status>
  </div>

  <button
    mat-fab
    [style.background-color]="backgroundColor()"
    (click)="toggleChat()"
    [attr.aria-label]="'INBOX.WEBCHAT.WIDGET.TOGGLE_WIDGET' | translate"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      fill="currentColor"
      class="webchat-icon"
      [ngClass]="{ 'webchat-icon--right': position() === 'right', 'webchat-icon--left': position() === 'left' }"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
    </svg>
  </button>
</div>
